// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDFWg_RDNgkEZmN-WzjJCsbamBSh1JCBsU",
  authDomain: "tatatrent-7b68e.firebaseapp.com",
  projectId: "tatatrent-7b68e",
  storageBucket: "tatatrent-7b68e.firebasestorage.app",
  messagingSenderId: "1073085149191",
  appId: "1:1073085149191:web:ebd8d9000392aa986e3aa2",
  measurementId: "G-1RFQFY5EVV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);